import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-logo-display',
    imports: [CommonModule],
    templateUrl: './logo-display.component.html',
    styleUrls: ['./logo-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoDisplayComponent {
  @Input()
  isHeader = false
  @Input()
  isPopup = false
  #questionnaireStore = inject(QuestionnaireStore)
  logo$ = this.#questionnaireStore.logo$;
  questionnaire$ = toSignal(this.#questionnaireStore.questionnaire$);
  secondaryColor$ = this.#questionnaireStore.secondaryColor$;
}
